import React, { useState } from 'react';
import '../css/FAQ.css';

const faqs = [
  {
    question: "What is TefDB?",
    answer:
      "TefDB is a web-based biological database dedicated to Eragrostis tef. It integrates biological data, including genomic, gene, protein sequence, and literature data into a single platform to support research, education, and crop improvement."
  },
  {
    question: "What type of data does TefDB provide?",
    answer:
      "TefDB provides genome assemblies, gene, nucleotide and protein sequenc, and literature records related to Eragrostis tef. The data are curated from publicly available biological repositories."
  },
  {
    question: "Who developed and maintains TefDB?",
    answer:
      "TefDB is developed and maintained by a research team led by Mr. Badasa Firdisa, with academic supervision from Dr. Abiy Zegeye and Dr. Adugna Abdi, in collaboration with Ethiopian academic and research institutions."
  },
  {
    question: "Which institutions support TefDB?",
    answer:
      "The platform is supported by Addis Ababa Science and Technology University (AASTU), Addis Ababa University (AAU), and Bio and Emerging Technology Institute (BETin)."
  },
  {
    question: "What bioinformatic tools are available in TefDB?",
    answer:
      "TefDB integrates commonly used bioinformatic tools including BLAST for sequence similarity search, Primer3Plus for primer design, Clustal Omega for multiple sequence alignment, and JBrowse 2 for genome visualization."
  },
  {
    question: "Can I use TefDB without registration?",
    answer:
      "Yes. Most data browsing and analysis tools in TefDB are freely accessible without registration. Registration may be required for data submission or advanced features."
  },
  {
    question: "How can I submit data or provide feedback?",
    answer:
      "Users can submit data or feedback through the Data Submission and Feedback sections of the platform. Submitted data are reviewed before being included in the database."
  },
  {
    question: "How should TefDB be cited?",
    answer:
      " "
  }
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <main className="faq-container">
      <h1 className="faq-title">Frequently Asked Questions (FAQs)</h1>

      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div className="faq-item" key={index}>
            <button
              className={`faq-question ${activeIndex === index ? 'active' : ''}`}
              onClick={() => toggleFAQ(index)}
            >
              {faq.question}
            </button>

            {activeIndex === index && (
              <div className="faq-answer">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </main>
  );
};

export default FAQ;

